import localStorage from "shared/helpers/localStorage";

export const resetSelection = () => {
  localStorage.remove("buyerSelections");
  localStorage.remove("sectionCompleted");
  location.reload();
};
